import { BlueberryPediatricsPage } from "#/pages/telemedicine/blueberry-pediatrics/page"
import { MedicalPrimePage } from "#/pages/telemedicine/medical-prime/page"
import { Paths } from "#/utils/Paths"

export const ContentfulControlledPageRoutes = [
  {
    path: Paths.TELEMEDICINE_FOR_PEDIATRICS,
    component: BlueberryPediatricsPage
  },
  {
    path: Paths.TELEMEDICINE_FOR_MENOPAUSE_CARE,
    component: MedicalPrimePage
  }
] as const
